<ol class="breadcrumb">
    <li>
        <a [routerLink]="['/submissions']">Submissions</a>
        /
        <a [routerLink]="['/submissions','submission',this.uuid]">Samples</a>
        /
        <a>Test Results</a>
    </li>
</ol>
<div class="card-table">
    <div *ngFor="let result of activeFileRecordList">
        <div *ngIf="result.haploids">
            <mat-card class="haploid-card">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="samp-locus">{{result.locus}}</div>
                    </div>
                    <div class="col-sm-7">
                        <span *ngFor="let haploid of result.haploids; let i = index">
                            <span class="samp-haploid">{{i > 0 ? ', ' : ''}}{{haploid}}</span>
                        </span>
                    </div>
                </div>
            </mat-card>
        </div>

        <div *ngIf="result.observation">
            <mat-card class="haploid-card">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="samp-locus">{{result.locus}}</div>
                    </div>
                    <div class="col-sm-7">
                        <span class="samp-observations" >{{result.observation}}</span>
                    </div>
                </div>
            </mat-card>
        </div>

        <div *ngIf="result.glString">
            <mat-card class="glstring-card">
                <div class="row">
                    <div class="col-sm-2">
                        <div class="samp-locus">{{result.locus}}</div>
                    </div>
                    <div class="col-sm-10">
                        <div class="samp-glstring">{{result.glString}}</div>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
</div>
